// Gerado por scripts/generate-app-meta.js — não editar manualmente
export const APP_NAME = "giuseppe"
export const APP_VERSION = "1.7.0"
